import Typography from '@mui/material/Typography';
import {useTranslation} from "react-i18next";
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getShortSpecName} from '../Trans.js';
import {taxStateDesc} from './TaxCommon.js';
import {TAB_TAX} from './TaxCommon.js';

function TaxLine(props) {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	if (!props.taxon)
		return null;

	function taxGetSpecName(tax) {
		return getShortSpecName(tax, gStorage.conn.user);
	}

	if (props.center) {
		return (
			<Grid size={{xs: 12}} align={'center'}>
				<Card variant='outlined' sx={{width:300, margin:2, backgroundColor: '#f8f8f8'}}>
					<Typography variant={'h6'}>{taxGetSpecName(props.taxon)}</Typography>
					<Typography variant={'body1'}>{props.taxon.sci}</Typography>
					<Typography variant={'body1'}>{props.taxon.en}</Typography>
					<Typography variant={'body1'}>{'(' + t(taxStateDesc(props.taxon.t_type)) + ')'}</Typography>
				</Card>
			</Grid>
		)
	}

	return (<Grid size={{xs: 12}} align={'center'}>
			<Typography variant={props.center === true ? "h6" : "body1"}>
				{t(taxStateDesc(props.taxon.t_type)) + ': '}
				<Link href="#" onClick={props.taxLink.bind(this, props.taxon.id)}>{taxGetSpecName(props.taxon)}</Link>
			</Typography>
		</Grid>
	);
}

const Taxonomy = observer((props) => {
	const gStorage = useGlobalStorage();
	const {taxLink} = props;

	if (gStorage.taxons.tab !== TAB_TAX)
		return null;

	return (<div>
			<TaxLine taxon={gStorage.taxons.upperTaxon4} taxLink={taxLink} />
			<TaxLine taxon={gStorage.taxons.upperTaxon3} taxLink={taxLink} />
			<TaxLine taxon={gStorage.taxons.upperTaxon2} taxLink={taxLink} />
			<TaxLine taxon={gStorage.taxons.upperTaxon1} taxLink={taxLink} />
			<TaxLine taxon={gStorage.taxons.centerTaxon} center={true} taxLink={taxLink} />

			{gStorage.taxons.childList.map((tax, ind) => {
				return <TaxLine taxon={tax} key={tax.id} taxLink={taxLink}/>
			})}
		</div>);
});

export default Taxonomy;
